<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('welcome.companyName') }}</span>
        <h3 class="page-title">{{ $t('welcome.clientPanel') }}</h3>
      </d-col>
    </d-row>

    <d-card>
      <d-card-header>
        <h5 class="text-center">{{ $t('welcome.welcomeToClientPanel') }}</h5>
      </d-card-header>

      <d-card-body>
        <d-card bg-theme="light">
          <d-card-header class="text-center text-light">
            <h4 class="text-dark mt-2"><strong class="font-weight-bold">{{ $t('welcome.wantToCheckOurProducts') }}</strong></h4>
          </d-card-header>

          <d-card-body class="pt-2 pb-5 pl-5 pr-5">
            <p
              class="text-center font-weight-light"
              v-pure-html="$t('welcome.productBrowserInfo')">
            </p>

            <p class="text-center">
              <d-button
                size="lg"
                @click.prevent="openProductsSearchPopup">
                {{ $t('welcome.searchProducts') }}
              </d-button>
            </p>

            <d-row class="d-flex flex-nowrap">
                <d-card
                  @click="openProductsSearchPopup(productMainCategories.typeTagID, productMainCategories.categories.category1)"
                  class="w-25 p-2 mx-3 main-category">
                  <img
                    src="@/assets/images/czapki-z-daszkiem.jpeg"
                    alt="" />
                  <p class="text-center pt-2">
                    <strong class="font-weight-bold">{{ $t('welcome.baseballCaps') }}</strong>
                  </p>
                </d-card>
                <d-card
                  @click="openProductsSearchPopup(productMainCategories.typeTagID, productMainCategories.categories.category2)"
                  class="w-25 p-2 mx-3 main-category">
                  <img
                    src="@/assets/images/czapki-zimowe.jpeg"
                    alt="" />
                  <p class="text-center pt-2">
                    <strong class="font-weight-bold">{{ $t('welcome.winterHats') }}</strong>
                  </p>
                </d-card>
                <d-card
                  @click="openProductsSearchPopup(productMainCategories.typeTagID, productMainCategories.categories.category3)"
                  class="w-25 p-2 mx-3 main-category">
                  <img
                    src="@/assets/images/daszki.jpeg"
                    alt="" />
                  <p class="text-center pt-2">
                    <strong class="font-weight-bold">{{ $t('welcome.capVizors') }}</strong>
                  </p>
                </d-card>
                <d-card
                  @click="openProductsSearchPopup(productMainCategories.typeTagID, productMainCategories.categories.category4)"
                  class="w-25 p-2 mx-3 main-category">
                  <img
                    src="@/assets/images/kapelusze.jpeg"
                    alt="" />
                  <p class="text-center pt-2">
                    <strong class="font-weight-bold">{{ $t('welcome.hats') }}</strong>
                  </p>
                </d-card>
            </d-row>
          </d-card-body>
        </d-card>

        <p
          class="mt-5 text-center"
          v-pure-html="$t('welcome.orderInfo')">
        </p>

        <d-row class="mt-2 mb-5">
          <d-col class="d-flex align-items-stretch">
            <d-card>
              <d-card-header class="text-center text-primary"><strong class="font-weight-bold">{{ $t('welcome.setp') }} 1.</strong></d-card-header>
              <d-card-body
                class="p-3 text-center font-weight-light"
                v-pure-html="$t('welcome.stepOneContent')">
              </d-card-body>
            </d-card>
          </d-col>

          <d-col class="d-flex align-items-stretch">
            <d-card>
              <d-card-header class="text-center text-primary"><strong class="font-weight-bold">{{ $t('welcome.setp') }} 2.</strong></d-card-header>
              <d-card-body
                class="p-3 text-center font-weight-light"
                v-pure-html="$t('welcome.stepTwoContent')">
              </d-card-body>
            </d-card>
          </d-col>

          <d-col class="d-flex align-items-stretch">
            <d-card>
              <d-card-header class="text-center text-primary"><strong class="font-weight-bold">{{ $t('welcome.setp') }} 3.</strong></d-card-header>
              <d-card-body
                class="p-3 text-center font-weight-light"
                v-pure-html="$t('welcome.stepThreeContent')">
              </d-card-body>
            </d-card>
          </d-col>

          <d-col class="d-flex align-items-stretch">
            <d-card>
              <d-card-header class="text-center text-primary"><strong class="font-weight-bold">{{ $t('welcome.setp') }} 4.</strong></d-card-header>
              <d-card-body
                class="p-3 text-center font-weight-light"
                v-pure-html="$t('welcome.stepFourContent')">
              </d-card-body>
            </d-card>
          </d-col>

          <d-col class="d-flex align-items-stretch">
            <d-card>
              <d-card-header class="text-center text-primary"><strong class="font-weight-bold">{{ $t('welcome.setp') }} 5.</strong></d-card-header>
              <d-card-body
                class="p-3 text-center font-weight-light"
                v-pure-html="$t('welcome.stepFiveContent')">
              </d-card-body>
            </d-card>
          </d-col>
        </d-row>

        <p class="mt-5 mb-3"
          v-pure-html="$t('welcome.orderWithNoAdditionInfo')">
        </p>

        <p
          class="font-weight-light mb-2"
          v-pure-html="$t('welcome.orderWithAdditionInfo')">
        </p>
      </d-card-body>
    </d-card>

    <products-search-popup
      v-if="productsSearchPopupIsOpen"
      :currency-id="customer.currency_id"
      :products-discount="parseFloat(customer.discount_products)"
      :selected-currency-symbol="selectedCurrencySymbol"
      :product-index="0"
      :selected-tag-category="selectedTagCategory"
      :selected-tag-category-value="selectedTagCategoryValue"
      :tag-categories="tagCategories" />
  </d-container>
</template>

<script>
import AppConfig from './../.env';
import CustomerPanel from './../mixins/CustomerPanel.vue';
import FormUtils from './../utils/FormUtils.js';
import ProductsSearchPopup from './../components/orders/ProductsSearchPopup.vue';

export default {
  name: 'dashboard',
  mixins: [
    CustomerPanel
  ],
  components: {
    'products-search-popup': ProductsSearchPopup
  },
  data () {
    return {
      customer: null,
      currencies: [],
      tagCategories: [],
      loadedCustomer: false,
      loadedCurrencies: false,
      loadedTagCategories: false,
      loadError: false,
      productsSearchPopupIsOpen: false,
      selectedTagCategory: null,
      selectedTagCategoryValue: null
    };
  },
  computed: {
    selectedCurrencySymbol () {
      let foundedCurrency = this.currencies.filter(currency => currency.id === this.customer.currency_id);

      if (foundedCurrency.length) {
        return foundedCurrency[0].code;
      }

      return '';
    },
    productMainCategories () {
      let environment = AppConfig.useConfig;
      return AppConfig.additionalConfig[environment].customerPanelSearch;
    }
  },
  mounted () {
    this.$bus.$on('products-search-popup-select-product', this.setProduct);
    this.$bus.$on('products-search-popup-close', this.closeProductsSearchPopup);
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: this.getApiEndpoint('/customers/item'),
        loadedKey: 'loadedCustomer',
        outputKey: 'customer',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: this.getApiEndpoint('/currencies/items'),
        loadedKey: 'loadedCurrencies',
        outputKey: 'currencies',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: this.getApiEndpoint('/tags/categories/items'),
        loadedKey: 'loadedTagCategories',
        outputKey: 'tagCategories',
        errorKey: 'loadError',
        params: {
          with: ['tags']
        }
      });
    },
    setProduct (productID) {
      this.$router.push('/zapytania/nowe/' + parseInt(productID, 10));
    },
    openProductsSearchPopup (categoryID, categoryTagID) {
      this.productsSearchPopupIsOpen = true;

      if (categoryID) {
        this.selectedTagCategory = categoryID;
      } else {
        this.selectedTagCategory = null;
      }

      if (categoryTagID) {
        this.selectedTagCategoryValue = categoryTagID;
      } else {
        this.selectedTagCategoryValue = null;
      }
    },
    closeProductsSearchPopup () {
      this.productsSearchPopupIsOpen = false;
    }
  },
  beforeDestroy () {
    this.$bus.$off('products-search-popup-select-product', this.setProduct);
    this.$bus.$off('products-search-popup-close', this.closeProductsSearchPopup);
  }
};
</script>

<style lang="scss" scoped>
.main-category {
  cursor: pointer;
}
</style>
